var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/form-validation.j2"] = require( "macros/form-validation.j2" );
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );
dependencies["modal/user/create/header.j2"] = require( "modal/user/create/header.j2" );
dependencies["modal/user/create/email-password.j2"] = require( "modal/user/create/email-password.j2" );
dependencies["modal/user/create/options.j2"] = require( "modal/user/create/options.j2" );
dependencies["modal/user/create/submit.j2"] = require( "modal/user/create/submit.j2" );
dependencies["modal/user/create/privacy-disclaimer.j2"] = require( "modal/user/create/privacy-disclaimer.j2" );
dependencies["modal/user/create/login-link.j2"] = require( "modal/user/create/login-link.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/modal/user/create/modal-create-contents.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/form-validation.j2", false, "core/templates/modal/user/create/modal-create-contents.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("displayGeneralErrors")) {
var t_4 = t_1.displayGeneralErrors;
} else {
cb(new Error("cannot import 'displayGeneralErrors'")); return;
}
context.setVariable("displayGeneralErrors", t_4);
if(t_1.hasOwnProperty("displayFieldErrors")) {
var t_5 = t_1.displayFieldErrors;
} else {
cb(new Error("cannot import 'displayFieldErrors'")); return;
}
context.setVariable("displayFieldErrors", t_5);
if(t_1.hasOwnProperty("hasErrors")) {
var t_6 = t_1.hasErrors;
} else {
cb(new Error("cannot import 'hasErrors'")); return;
}
context.setVariable("hasErrors", t_6);
if(t_1.hasOwnProperty("validatedField")) {
var t_7 = t_1.validatedField;
} else {
cb(new Error("cannot import 'validatedField'")); return;
}
context.setVariable("validatedField", t_7);
output += "\n";
env.getTemplate("macros/urls.j2", false, "core/templates/modal/user/create/modal-create-contents.j2", false, function(t_9,t_8) {
if(t_9) { cb(t_9); return; }
t_8.getExported(context.getVariables(), frame, function(t_10,t_8) {
if(t_10) { cb(t_10); return; }
if(t_8.hasOwnProperty("genericUrl")) {
var t_11 = t_8.genericUrl;
} else {
cb(new Error("cannot import 'genericUrl'")); return;
}
context.setVariable("genericUrl", t_11);
if(t_8.hasOwnProperty("signUpUrl")) {
var t_12 = t_8.signUpUrl;
} else {
cb(new Error("cannot import 'signUpUrl'")); return;
}
context.setVariable("signUpUrl", t_12);
if(t_8.hasOwnProperty("loginUrl")) {
var t_13 = t_8.loginUrl;
} else {
cb(new Error("cannot import 'loginUrl'")); return;
}
context.setVariable("loginUrl", t_13);
output += "\n\n\n";
if(runtime.contextOrFrameLookup(context, frame, "renderedOutsideOfModal")) {
output += "\n\n<div class=\"s-user-auth-standalone u-clearfix\">\n\n    <div class=\"o-row\">\n\n        <div class=\"o-column o-extra-small--12 o-small--8 o-small--offset-2 o-large--5 o-large--offset-1 o-extra-large--4 o-extra-large--offset-2 c-modal-login__section-1\">\n\n            ";
env.getTemplate("modal/user/create/header.j2", false, "core/templates/modal/user/create/modal-create-contents.j2", null, function(t_16,t_14) {
if(t_16) { cb(t_16); return; }
t_14.render(context.getVariables(), frame, function(t_17,t_15) {
if(t_17) { cb(t_17); return; }
output += t_15
output += "\n\n            <form novalidate class=\"js-signup-form\" method=\"post\" action=\"\" enctype=\"application/x-www-form-urlencoded\">\n\n                ";
env.getTemplate("modal/user/create/email-password.j2", false, "core/templates/modal/user/create/modal-create-contents.j2", null, function(t_20,t_18) {
if(t_20) { cb(t_20); return; }
t_18.render(context.getVariables(), frame, function(t_21,t_19) {
if(t_21) { cb(t_21); return; }
output += t_19
output += "\n\n                <div class=\"o-row o-column o-extra-small--12\">\n\n                    ";
env.getTemplate("modal/user/create/options.j2", false, "core/templates/modal/user/create/modal-create-contents.j2", null, function(t_24,t_22) {
if(t_24) { cb(t_24); return; }
t_22.render(context.getVariables(), frame, function(t_25,t_23) {
if(t_25) { cb(t_25); return; }
output += t_23
output += "\n\n                </div>\n\n                ";
env.getTemplate("modal/user/create/submit.j2", false, "core/templates/modal/user/create/modal-create-contents.j2", null, function(t_28,t_26) {
if(t_28) { cb(t_28); return; }
t_26.render(context.getVariables(), frame, function(t_29,t_27) {
if(t_29) { cb(t_29); return; }
output += t_27
output += "\n\n                ";
env.getTemplate("modal/user/create/privacy-disclaimer.j2", false, "core/templates/modal/user/create/modal-create-contents.j2", null, function(t_32,t_30) {
if(t_32) { cb(t_32); return; }
t_30.render(context.getVariables(), frame, function(t_33,t_31) {
if(t_33) { cb(t_33); return; }
output += t_31
output += "\n\n            </form>\n\n        </div>\n\n        <div class=\"o-column o-extra-small--12 o-small--8 o-small--offset-2 o-large--5 o-extra-large--4 c-modal-login__section-2\">\n\n            <h2 class=\"c-modal-login__secondary-heading\">\n                ";
output += runtime.suppressValue((lineno = 35, colno = 18, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["modal-login_member-heading",runtime.makeKeywordArgs({"state": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += "\n            </h2>\n\n            ";
env.getTemplate("modal/user/create/login-link.j2", false, "core/templates/modal/user/create/modal-create-contents.j2", null, function(t_36,t_34) {
if(t_36) { cb(t_36); return; }
t_34.render(context.getVariables(), frame, function(t_37,t_35) {
if(t_37) { cb(t_37); return; }
output += t_35
output += "\n\n        </div>\n\n    </div>\n\n</div>\n\n";
})})})})})})})})})})})});
}
else {
output += "\n\n    <form novalidate class=\"js-signup-form ";
output += runtime.suppressValue((lineno = 48, colno = 53, runtime.callWrap(t_6, "hasErrors", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"modal")),"create")),"messages")),"generalErrors")])), env.opts.autoescape);
output += "\" method=\"post\" action=\"\" enctype=\"application/x-www-form-urlencoded\" data-parsley-validate data-qa-modal-sign-up>\n\n        <div class=\"o-row c-modal-login\" data-qa-modal-signin>\n\n            <div class=\"o-column o-extra-small--12\">\n\n                <div class=\" c-modal-login__text\">\n\n                    ";
env.getTemplate("modal/user/create/header.j2", false, "core/templates/modal/user/create/modal-create-contents.j2", null, function(t_40,t_38) {
if(t_40) { cb(t_40); return; }
t_38.render(context.getVariables(), frame, function(t_41,t_39) {
if(t_41) { cb(t_41); return; }
output += t_39
output += "\n\n                </div>\n\n            </div>\n\n        </div>\n\n        <div class=\"o-row\">\n\n            <div class=\"o-column o-extra-small--12 c-modal-login__form\">\n\n                ";
env.getTemplate("modal/user/create/email-password.j2", false, "core/templates/modal/user/create/modal-create-contents.j2", null, function(t_44,t_42) {
if(t_44) { cb(t_44); return; }
t_42.render(context.getVariables(), frame, function(t_45,t_43) {
if(t_45) { cb(t_45); return; }
output += t_43
output += "\n\n                <div>\n\n                    ";
env.getTemplate("modal/user/create/options.j2", false, "core/templates/modal/user/create/modal-create-contents.j2", null, function(t_48,t_46) {
if(t_48) { cb(t_48); return; }
t_46.render(context.getVariables(), frame, function(t_49,t_47) {
if(t_49) { cb(t_49); return; }
output += t_47
output += "\n\n                </div>\n\n            </div>\n\n        </div>\n\n        <div class=\"o-row\">\n\n            <div class=\"o-column o-extra-small--12 c-modal-login__buttons u-clearfix\">\n\n                ";
env.getTemplate("modal/user/create/submit.j2", false, "core/templates/modal/user/create/modal-create-contents.j2", null, function(t_52,t_50) {
if(t_52) { cb(t_52); return; }
t_50.render(context.getVariables(), frame, function(t_53,t_51) {
if(t_53) { cb(t_53); return; }
output += t_51
output += "\n\n                ";
env.getTemplate("modal/user/create/privacy-disclaimer.j2", false, "core/templates/modal/user/create/modal-create-contents.j2", null, function(t_56,t_54) {
if(t_56) { cb(t_56); return; }
t_54.render(context.getVariables(), frame, function(t_57,t_55) {
if(t_57) { cb(t_57); return; }
output += t_55
output += "\n\n            </div>\n\n        </div>\n\n        <div class=\"o-row\">\n\n            <div class=\"o-column o-extra-small--12\">\n\n                <h2 class=\"c-modal-login__secondary-heading\">\n                    ";
output += runtime.suppressValue((lineno = 97, colno = 22, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["modal-login_member-heading",runtime.makeKeywordArgs({"state": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += "\n                </h2>\n\n                ";
env.getTemplate("modal/user/create/login-link.j2", false, "core/templates/modal/user/create/modal-create-contents.j2", null, function(t_60,t_58) {
if(t_60) { cb(t_60); return; }
t_58.render(context.getVariables(), frame, function(t_61,t_59) {
if(t_61) { cb(t_61); return; }
output += t_59
output += "\n\n            </div>\n\n        </div>\n\n    </form>\n\n";
})})})})})})})})})})})});
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/modal/user/create/modal-create-contents.j2"] , dependencies)